export const userPermissionTypes = {
  admin: 'admin',
  superAdmin: 'super admin',
  support: 'support',
  releaseManager: 'release manager',
  customer: 'customer',
};
